import { render } from "./SeleccionUbicacionesPage.vue?vue&type=template&id=44b6f14c&scoped=true"
import script from "./SeleccionUbicacionesPage.vue?vue&type=script&lang=js"
export * from "./SeleccionUbicacionesPage.vue?vue&type=script&lang=js"

import "./SeleccionUbicacionesPage.vue?vue&type=style&index=0&id=44b6f14c&scoped=true&lang=scss"
import "./SeleccionUbicacionesPage.vue?vue&type=style&index=1&id=44b6f14c&scoped=true&lang=css"

import exportComponent from "C:\\GIT CLONADO\\ubiku.2023\\com.ubiku.ges.ios\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-44b6f14c"]])

export default __exports__